import type { ReactNode } from 'react';
import { createStore } from '../utils';

export type ToastInStore = {
  id: number;
  title: string;
  text?: ReactNode;
  duration: number;
};

export const toastsStore = createStore<ToastInStore[]>([]);
